import { decodeLocationsResponse } from "./proto/locationsDecoder";
import { decodeOffersListResponse } from "./proto/offersListDecoder";

const { DEV } = import.meta.env;

const PROTOBUF_GET_DECODERS = {
    "/app_rispromo/offers_list": decodeOffersListResponse,
    "/app_rispromo_supply/locations": decodeLocationsResponse,
};
const PROTOBUF_CONTENT_TYPES = new Set(["application/protobuf", "application/x-protobuf"]);

const getContentType = (response) => {
    const contentType = response?.headers?.["content-type"] || response?.headers?.get?.("content-type") || "";

    return contentType.split(";", 1)[0].trim().toLowerCase();
};

const decodeJson = async (data) => {
    if (data === null || data === undefined || data === "") return null;
    if (typeof data === "object" && !(data instanceof ArrayBuffer) && !ArrayBuffer.isView(data) && !(typeof Blob !== "undefined" && data instanceof Blob)) return data;

    let bytes = data;
    if (typeof Blob !== "undefined" && data instanceof Blob) bytes = await data.arrayBuffer();

    const text = typeof bytes === "string" ? bytes : new TextDecoder("utf-8").decode(bytes);
    return text ? JSON.parse(text) : null;
};

const decodeGetResponse = async (response, url) => {
    const contentType = getContentType(response);
    const protobufDecoder = PROTOBUF_GET_DECODERS[url];
    const isJson = contentType === "application/json" || contentType.endsWith("+json");
    const isProtobuf = PROTOBUF_CONTENT_TYPES.has(contentType) || (contentType === "application/octet-stream" && protobufDecoder);

    if (DEV) console.debug(`[GET] ${url}: ${contentType || "Content-Type не указан"}`);

    if (isJson) return decodeJson(response.data);

    if (isProtobuf) {
        if (!protobufDecoder) {
            throw new Error(`Для protobuf-ответа ${url} не зарегистрирован декодер`);
        }

        return protobufDecoder(response.data);
    }

    try {
        return await decodeJson(response.data);
    } catch {
        if (protobufDecoder) return protobufDecoder(response.data);
        throw new Error(`Неизвестный Content-Type "${contentType || "не указан"}" для ${url}`);
    }
};

export { decodeGetResponse, decodeJson, getContentType };
